module.exports = __webpack_public_path__ + "img/photo-0145.966ddde4.jpg";